import { Component, HostListener, OnInit } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State } from 'src/app/core/store';
import { loadProfile, getPhoto, getReturnEquipmentAlerts } from 'src/app/core/store/profile/profile.actions';
import { UserProfileModel } from 'src/app/models/userProfileModel';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/abstracts/baseComponent';
import { daysBetween, getRequiredDocumentReminderDays, isCaqhActionRequired, isCaqhQuestionnaireCurrent, REQUIRED_DOCUMENT_URGENT_REMINDER_DAYS } from '../../../helpers/utils';
import { FormBuilderService } from '../../../core/services/formBuilder.service';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { getFeatureSwitches } from 'src/app/core/store/account/account.actions';
import { getSelfCareAppURL, getSelfCareAppURLSuccess } from '../../../core/store/selfcare/selfcare.actions';
import { tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent extends BaseComponent implements OnInit {

  @HostListener('window:resize', ['$event']) onWindowResize() {
    this.screenWidth = window.innerWidth;
  }

  modalReference: any;
  modalOptions: NgbModalOptions;
  profile: UserProfileModel;
  profilePicture;
  canSeeSelfcare;
  canViewEquipment;
  canAccessCriticalNewsFeed: boolean = false;
  canViewCriticalNewsFeed;
  canViewBenefits;
  canViewReferrals;
  hasAnyDoc;
  notSignedDocs;
  canViewForms;
  canViewMedClinic;
  canViewConferenceEligibility;
  returnEquipmentAlert: string = null;
  returnEquipmentAlertCount: number = 0;
  screenWidth: number;
  showNewsFeedModal: boolean = false;
  profileLoaded: boolean;
  requiredDocumentsReminderDismissed: boolean = false;

  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  gettingCaqhForm: boolean = false;

  constructor(
    private http: HttpClient,
    private actions$: Actions,
    private store: Store<State>,
    private router: Router,
    private modalService: NgbModal,
    private formBuilderService: FormBuilderService,
    private confirmationService: ConfirmationService
  ) {
    super();
    this.screenWidth = window.innerWidth;
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      windowClass : "newsFeedModal",
    }
  }

  ngOnInit() {
    this.profileLoaded = false;
    this.store.dispatch(getReturnEquipmentAlerts({id: this.currentUser.id}))
    this.subs.push(
      this.store.select(s => s.profileState.profile).subscribe(profile => {
        this.profile = profile;
        if (profile) {
          this.profileLoaded = true;
          this.requiredDocumentsReminderDismissed = localStorage.getItem(this.getRequiredDocumentsReminderStorageKey()) === 'true';
          setTimeout(()=> {window.scrollTo(0,0)}, 100);
          if (profile.isOnBoarding) {
            this.router.navigate(['/onboarding']);
          }
        }
      }),
      this.store.select(s => s.profileState.photoUrl).subscribe(photoUrl => {
        this.profilePicture = photoUrl;
      }),
      this.store.select(s => s.profileState.returnEquipmentAlert).subscribe(returnEquipmentAlert => {
        this.returnEquipmentAlert = returnEquipmentAlert;
      }),
      this.store.select(s => s.profileState.returnEquipmentAlertCount).subscribe(returnEquipmentAlertCount => {
        this.returnEquipmentAlertCount = returnEquipmentAlertCount;
      }),
      this.store.select(s => s.accountState.featureSettingsIds).subscribe(featureSettingsIds => {
        this.canViewReferrals = featureSettingsIds && (!!featureSettingsIds.find(p => p === 3008)); //Referral
      }),
      this.store.select(s => s.accountState.featureSwitchesIds).subscribe(featureSwitchesIds => {
        this.canViewEquipment = featureSwitchesIds && !!featureSwitchesIds.find(p => p === 80); // Equipment
        this.canAccessCriticalNewsFeed = featureSwitchesIds && !!featureSwitchesIds.find(p => p === 114); // Critical News Feed
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canViewBenefits = permissionIDs && !!permissionIDs.find(p =>
          p === 6051
        );
        this.canViewBenefits = permissionIDs && !!permissionIDs.find(p => p === 6051);
        this.canViewForms = permissionIDs && !!permissionIDs.find(p => p === 9002);
        this.canViewCriticalNewsFeed = permissionIDs && !!permissionIDs.find(p => p === 9501 || p === 9500 || p === 9505 || p === 9504 || p === 9503 || p === 9502);
        this.canViewMedClinic = permissionIDs && !!permissionIDs.find(p => p === 11001);
        this.canSeeSelfcare = permissionIDs && !!permissionIDs.find(p => p === 3083); //See Self-Care
        this.canViewConferenceEligibility = permissionIDs
          && !!permissionIDs.find(p => p === 6064);

      }),

      this.store.select(s => s.benefitsState.docsListBenefit).subscribe(enrollmentFormDocs => {
        if (enrollmentFormDocs) {

          this.hasAnyDoc = enrollmentFormDocs.length > 0;
          this.notSignedDocs = enrollmentFormDocs.filter(doc => !doc.signedDate).length;
        }
      }),

      this.actions$.pipe(
        ofType(getSelfCareAppURLSuccess),
        tap((action) => {
          console.info(action);

          window.open(action.url, 'iAM360');

        })
      ).subscribe(),
    );
    
    this.store.dispatch(getFeatureSwitches());
    this.store.dispatch(loadProfile());
    this.store.dispatch(getPhoto());

    if (this.router.url.split('?')[0] === '/form-filling/caqh') {
      this.fillCaqhForm();
    }

   

  }

  openNewsFeed(e) {
    this.showNewsFeedModal = !this.showNewsFeedModal;
    e.stopPropagation();
  }

  openSelfCare() {


    return this.http.get<{ url: string }>(`${environment.apiServer.webApiURL}/SelfCare/GetSelfCareAppURL`).
      subscribe((res) => {
        

        window.open(res.url, 'iAM360');

      });

    //this.store.dispatch(getSelfCareAppURL(null));
  }

  openLink(path) {
    this.router.navigate([path]);
  }

  openEnrollment() {
      this.router.navigate(['benefits-enrollment/enrollment']);
  }

  openMedClinic() {
    this.router.navigate(['medclinic/patients-list']);
}

  fillCaqhForm() {
    this.gettingCaqhForm = true;
    this.formBuilderService.fillCAQHForm().subscribe(form => {
      if (form.formSubmission) {
        this.router.navigate(['/form-filling/fill/' + form.form.id + '/' + form.formSubmission.id]);
      } else {
        this.router.navigate(['/form-filling/fill/' + form.form.id]);
      }
      this.gettingCaqhForm = false;
    });
  }

  isCaqhQuestionnaireNewer() {
    if (this.profile == null)
      return false;

    return isCaqhQuestionnaireCurrent(this.profile.caqhQuestionnaireSentDate, this.profile.caqhExpirationDate);
  }

  caqhDaysToExpire() {
    if (this.profile != null && this.profile.caqhExpirationDate != null)
      return daysBetween(new Date(), new Date(this.profile.caqhExpirationDate));
    return null;
  }

  requiredDocumentReminderDays() {
    return getRequiredDocumentReminderDays(this.profile?.requiredDocumentReminderDueDate);
  }

  showRequiredDocumentsReminder() {
    return this.requiredDocumentReminderDays() != null && !this.requiredDocumentsReminderDismissed;
  }

  isRequiredDocumentsReminderUrgent() {
    const daysUntilDue = this.requiredDocumentReminderDays();
    return daysUntilDue != null && daysUntilDue <= REQUIRED_DOCUMENT_URGENT_REMINDER_DAYS;
  }

  getRequiredDocumentsReminderStorageKey() {
    const dueDate = new Date(this.profile?.requiredDocumentReminderDueDate);
    const today = new Date();
    const dueDateKey = isNaN(dueDate.getTime())
      ? 'unknown'
      : `${dueDate.getFullYear()}${String(dueDate.getMonth() + 1).padStart(2, '0')}${String(dueDate.getDate()).padStart(2, '0')}`;
    const todayKey = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    return `RequiredDocumentsReminderDismissed_${this.currentUser?.id || 'unknown'}_${dueDateKey}_${todayKey}`;
  }

  reviewRequiredDocuments() {
    this.router.navigate(['/form-filling/list']);
  }

  dismissRequiredDocumentsReminder() {
    const daysUntilDue = this.requiredDocumentReminderDays();
    if (daysUntilDue == null) {
      return;
    }

    const dayText = daysUntilDue === 1 ? 'day' : 'days';
    this.confirmationService.confirm({
      header: 'Review required forms later?',
      message: `These forms are due in ${daysUntilDue} ${dayText}. If you continue without reviewing them, this reminder will return tomorrow.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Remind Me Tomorrow',
      rejectLabel: 'Go Back',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
      accept: () => {
        localStorage.setItem(this.getRequiredDocumentsReminderStorageKey(), 'true');
        this.requiredDocumentsReminderDismissed = true;
      }
    });
  }

  checkTermed() {
    return this.profile != null && this.profile.employee != null && this.profile.employee.terminationDate != null;
  }

  checkDisable() {
    return (this.profile != null && this.profile.pendingRequiredDocumentsCount > 0) || (this.profile.driversLicenseExpired == true) ||
      (this.profile != null && isCaqhActionRequired(this.profile.caqhExpirationDate, this.profile.caqhQuestionnaireSentDate));
  }

  setAssetAlertTitle(pendingDocCount, returnEquipmentCount){
    if (pendingDocCount == 0 && returnEquipmentCount > 0){
      return `You have ${returnEquipmentCount} equipment(s) to return`;
    }
    else if (pendingDocCount > 0 && returnEquipmentCount == 0){
      return `You have ${pendingDocCount} documents`;
    }
    else{
      return `You have ${pendingDocCount} documents to sign and ${returnEquipmentCount} equipment(s) to return`;
    }
  }

}
